import { useDroppable } from "@dnd-kit/core"
import React from "react"
import { cn } from "../../styles/utils"

interface DroppableProps {
  id: string
  children?: React.ReactNode
  disabled?: boolean
  data?: any
  className?: string
  hoverClassName?: string
}

export const Droppable: React.FC<DroppableProps> = ({
  id,
  children,
  disabled = false,
  data,
  className,
  hoverClassName = "bg-blue-500/10",
}) => {
  const { isOver, setNodeRef } = useDroppable({
    id,
    disabled,
    data,
  })

  return (
    <div
      ref={setNodeRef}
      className={cn(
        "transition-colors duration-200 ease-out",
        className,
        isOver && hoverClassName,
      )}
    >
      {children}
    </div>
  )
}
